import React from "react";
import BaseMemoryGame from "../../games/Memory/BaseMemoryGame";

const SENIOR_LIVING_MEMORY_ITEMS = [
  { id: 1, title: "Pancakes", image: "🥞" },
  { id: 2, title: "Coffee Mug", image: "☕️" },
  { id: 3, title: "Ice Cream Sundae", image: "🍦" },
  { id: 4, title: "Cheeseburger", image: "🍔" },
  { id: 5, title: "Milkshake", image: "🥤" },
  { id: 6, title: "Pie Slice", image: "🥧" },
];

function SeniorLivingMemoryGame() {
  return (
    <BaseMemoryGame
      title="Retro Diner Memory"
      subtitle="Match the menu item to its emoji!"
      shareText="I just played Retro Diner Memory on Flying Comet Games!"
      shareUrl={window.location.href}
      successBackgroundColor="#FFD97D"
      shareButtonColor={["#FFD97D", "#5C4B3A"]}
      customItems={SENIOR_LIVING_MEMORY_ITEMS}
      publicationId="SeniorLivingMemoryGame"
      hideTitle={false}
      showDatePicker={false}
    />
  );
}

export default SeniorLivingMemoryGame;
